module.exports = __webpack_public_path__ + "static/img/bg-es.b7c366e8.png";